<template>
  <div
    class="asc-full-screen-icon-wrapper"
    @click="handleFullScreenClick($event)"
  >
    <v-icon class="v-icon" :size="size">
      {{ isFullScreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'AscFullScreenIcon',

  props: {
    size: {
      type: Number,
      default: 16,
    },
  },

  data() {
    return { isFullScreen: false }
  },

  methods: {
    handleFullScreenClick(event) {
      this.isFullScreen = !this.isFullScreen
      this.$emit('onFullScreenToggle', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-full-screen-icon-wrapper {
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  cursor: pointer;
  background: $gray-200;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;

  &:hover {
    background: $accent-200;
  }

  .v-icon {
    color: $primary-black;
  }
}
</style>
